import { chart } from "../expendPlugins/chart/plugin";
import { registerVChartPlugin } from "../expendPlugins/vchart/plugin";
import { fileImport } from "../expendPlugins/fileImport/plugin";
import { fileExport } from "../expendPlugins/fileExport/plugin";

const pluginsObj = {
	chart: chart,
	vchart: registerVChartPlugin,
	fileImport: fileImport,
	fileExport: fileExport,
};

const isDemo = true;

/**
 * Register plugins
 */
function initPlugins(plugins, data) {
	if (!plugins.length) return;
	/**
	 * 20250822 为了解决插件资源找不到|路径等其他问题，将改为 用户主动传递式实现
	 */
	plugins.forEach(({ name, dependScripts = [], dependLinks = [] }) => {
		// 如果注册的插件不存在
		if (!pluginsObj[name]) {
			alert(`Plugin ${name} not supported`);
			throw new Error(`Plugin ${name} not supported`);
		}

		// 不然就执行对应插件方法,并传递用户主动传入的参数
		pluginsObj[name](data, isDemo, dependScripts.length ? dependScripts : null, dependLinks.length ? dependLinks : null);
	});
}

export { initPlugins };
